/**
 * useTutorCloseOutVoices — les vocaux du bilan, prêts pour la page : la réécoute (un seul vocal à la
 * fois, par le lecteur commun `useVoicePlayer`), le vocal qui joue et sa progression. Composé ici pour
 * que `TutorCloseOutScreen` reste un fil ; l'enregistrement, lui, est `useTutorCloseOutRecorder`.
 */
import { type TutorCloseOutViewModel } from "../../../../view-models/tutor/Lives/tutorCloseOutViewModel"
import { useVoicePlayer } from "../../../hooks/useVoicePlayer"

const PLATFORM_VOICE = "platform"
const studentVoiceId = (id: string | number) => `student:${id}`

type Voice = { uri: string; durationLabel: string } | null

export function useTutorCloseOutVoices(vm: TutorCloseOutViewModel) {
    const player = useVoicePlayer(null)
    const replay = (voiceId: string, voice: Voice) => {
        if (voice != null) player.toggle(voiceId, voice.uri)
    }
    const playingStudent = vm.students.find((student) => studentVoiceId(student.id) === player.messageId)
    const playingVoiceId = !player.playing
        ? null
        : player.messageId === PLATFORM_VOICE
          ? PLATFORM_VOICE
          : (playingStudent?.id ?? null)

    return {
        playingVoiceId,
        playingVoiceProgress: player.progress,
        onToggleStudentVoicePlay: (id: string | number) => {
            const student = vm.students.find((candidate) => candidate.id === id)
            if (student != null && student.absent === false) replay(studentVoiceId(id), student.comment.voice)
        },
        onTogglePlatformVoicePlay: () => replay(PLATFORM_VOICE, vm.platform.comment.voice),
    }
}
